import React, { FunctionComponent } from 'react';
import SummaryDiscount from './SummaryDiscount';
import { GetCustomizeCar_customizeCar_prices_carPrice_offers_discounts as IDiscount } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';

export interface IDiscountsListProps {
  loading?: boolean;
  currency: string;
  discounts: IDiscount[];
}

const SummaryDiscountsList: FunctionComponent<IDiscountsListProps> = ({ loading, currency, discounts }) => (
  <>
    {discounts?.map((discount, index) => (
      <SummaryDiscount
        key={index}
        currency={currency}
        loading={loading}
        discount={discount}
        label={discount.label}
        boldLabel={false}
        boldPrice={true}
      />
    ))}
  </>
);

export default SummaryDiscountsList;
